import React, { useContext, useEffect } from 'react';
import CoveringTable from '../components/tables/covering/CoveringTable';
import EmployeeTable from '../components/tables/employee/EmployeeTable';
import OfficeTableContainer from '../components/tables/office/OfficeTableContainer';
import CustomerTable from '../components/tables/customer/CustomerTable';
import { DataContext } from '../store';
import { usePath } from 'hookrouter';
import { A } from 'hookrouter';
import { useTranslation } from 'react-i18next';
import { HOME_EMPLOYEE_OPT, HOME_CUSTOMER_OPT, HOME_OFFICE_OPT, HOME_COVERINGS_OPT} from '../i18n/keyConstants';

const Home = () => {
    const {
        store: { user, activeTab },
        dispatch,
    } = useContext(DataContext);
    const path = usePath();
    const { t } = useTranslation(['navMenu']);

    useEffect(() => {
        dispatch({ type: 'ACTIVE_TAB_AND_LOADED_TABS', path, payload: true });
    }, [path, dispatch]);

    const hasAllTabAccess = user && (user.isAdmin || user.isEcoOrSales || user.isOfficeBoss);
    const hasCoveringsTabAccess = user && (user.isRecruiter || user.isMgr || hasAllTabAccess);

    return (
        <>
            <ul className='nav nav-tabs margin-none' role='tablist'>
                <li className='nav-item'>
                    <A
                        className={'nav-link ' + (activeTab === '/employees' ? 'active' : '')}
                        id='employees-tab'
                        data-toggle='tab'
                        href='/employees'
                        role='tab'
                        aria-controls='employee'
                        aria-selected='true'>
                        {t(HOME_EMPLOYEE_OPT)}
                    </A>
                </li>
                {hasAllTabAccess ? (
                    <li className='nav-item'>
                        <A
                            className={'nav-link ' + (activeTab === '/customers' ? 'active' : '')}
                            id='customers-tab'
                            data-toggle='tab'
                            href='/customers'
                            role='tab'
                            aria-controls='customer'
                            aria-selected='false'>
                            {t(HOME_CUSTOMER_OPT) }
                        </A>
                    </li>
                ) : null}
                <li className='nav-item'>
                    <A
                        className={'nav-link ' + (activeTab === '/offices' || activeTab === '/offices/internalhours' ? 'active' : '')}
                        id='offices-tab'
                        data-toggle='tab'
                        href='/offices'
                        role='tab'
                        aria-controls='office'
                        aria-selected='false'>
                        {t(HOME_OFFICE_OPT)}
                    </A>
                </li>
                {hasCoveringsTabAccess ? (
                    <li className='nav-item'>
                        <A
                            className={'nav-link ' + (activeTab === '/coverings' ? 'active' : '')}
                            id='coverings-tab'
                            data-toggle='tab'
                            href='/coverings'
                            role='tab'
                            aria-controls='covering'
                            aria-selected='false'>
                            {t(HOME_COVERINGS_OPT)}
                        </A>
                    </li>
                ) : null}
            </ul>
            <div className='tab-content'>
                {activeTab === '/employees' ? (
                    <div className={'tab-pane fade show active'} id='employee' role='tabpanel' aria-labelledby='employee-tab'>
                        <EmployeeTable />
                    </div>
                ) : null}
                {hasAllTabAccess ? (
                    <>
                        {activeTab === '/customers' ? (
                            <div className={'tab-pane fade show active'} id='customer' role='tabpanel' aria-labelledby='customer-tab'>
                                <CustomerTable />
                            </div>
                        ) : null}
                    </>
                ) : null}
                <>
                    {activeTab === '/offices' || activeTab === '/offices/internalhours' ? (
                        <div className={'tab-pane fade show active'} id='office' role='tabpanel' aria-labelledby='office-tab'>
                            <OfficeTableContainer hasOfficeHoursTabAccess={hasAllTabAccess} activeTab={activeTab} />
                        </div>
                    ) : null}
                </>
                {hasCoveringsTabAccess ? (
                    <>
                        {activeTab === '/coverings' ? (
                            <div className={'tab-pane fade show active'} id='covering' role='tabpanel' aria-labelledby='covering-tab'>
                                <CoveringTable />
                            </div>
                        ) : null}
                    </>
                ) : null}
            </div>
        </>
    );
};

export default Home;
